import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Index from './components/Todos/Index';

const App = () => {
    return (
        <Container className="my-4">
            <Row>
                <Col>
                    <Index />
                </Col>
            </Row>
        </Container>
    );
};

export default App;